import * as React from "react";
import { SVGProps } from "react";
const SvgSun = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#sun_svg__a)">
      <path
        fill="currentColor"
        d="M16 26a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm-8.485-2.929a1 1 0 0 1 1.414 1.414L6.1 27.314A1 1 0 0 1 4.687 25.9l2.829-2.829Zm15.56.004a1 1 0 0 1 1.41-.003l2.829 2.828a1 1 0 0 1-1.414 1.414l-2.829-2.828a1 1 0 0 1 .003-1.411ZM16 8a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm15 7a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h4ZM5 15a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2h4ZM25.9 4.686a1 1 0 0 1 1.414 1.415l-2.828 2.828a1 1 0 0 1-1.414-1.414L25.9 4.686ZM4.69 4.69a1 1 0 0 1 1.41-.003L8.93 7.515a1 1 0 0 1-1.414 1.414L4.686 6.1a1 1 0 0 1 .003-1.41ZM16 0a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1Z"
      />
    </g>
    <defs>
      <clipPath id="sun_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSun;
